<template>
  <div>
    <Tooltip
      :disabled="!localModel?.name"
      :content="localModel?.name || ''"
      effect="dark"
    >
      <el-select
        v-bind="$attrs"
        v-model="localModel.name"
        v-tooltip
        :ref="field.name || 'dropdown'"
        :data-name="field.name"
        plain
        :popper-class="`multigroup-select`"
        :value-key="'id'"
        filterable
        no-data-text="Справочник пуст"
        no-match-text="Ничего не найдено"
        :size="size"
        :required="field.required"
        :readonly="field.readonly || ''"
        :placeholder="
          hidden(field)
            ? 'Недоступно для редактирования'
            : field.placeholder || ''
        "
        :disabled="disabled(field) || field.disabled || !!hidden(field)"
        :filter-method="filter"
        class="dropdown-el"
        :class="{
          big: size === 'big',
          medium: size === 'medium',
          small: size === 'small',
          'is-error':
            !!field.error || (simpleErrors && field.required && !localModel),
          'no-label': !!$attrs['no-label'],
          'is-readonly': !!field.readonly,
          clearable: true
        }"
        @change="changeValue"
        @visible-change="visibleChange"
        @blur="blur"
      >
        <i
          v-if="showClearButton"
          @click="clear"
          :class="['el-input__icon el-icon-close']"
          ref="clear_icon"
        ></i>
        <component :is="`style`">
          .popup-select, .multigroup-select { max-width: {{ maxOptionsWidth }};
          }
        </component>
        <template v-if="!Object.keys($slots).length">
          <el-option class="empty-opt" label="" value=""></el-option>
          <template v-if="simpleOptions">
            <el-option
              v-tooltip
              v-for="(val, key) in simpleOptions"
              :key="key"
              :label="formatHtml(val) || ''"
              :value="key"
              :class="['dropdown-el__option']"
            >
              <span class="dropdown-el__option-item">
                {{ val || '' | format }}
              </span>
            </el-option>
          </template>
          <el-tree
            v-else-if="options.length && !simpleOptions"
            v-tooltip
            :key="updateTree"
            ref="tree"
            :data="simpleOptions === false ? [] : options"
            empty-text="Справочник пуст"
            :props="props"
            node-key="id"
            :defaultExpandAll="autoExpandAll"
            :default-checked-keys="defaultCheckedKeys"
            :current-node-key="defaultCheckedKeys[0] || ''"
            :highlight-current="true"
            :show-checkbox="multiple"
            :check-on-click-node="multiple"
            :expand-on-click-node="false"
            :load="loadNode"
            :filter-node-method="() => {}"
            lazy
            @node-click="handleNodeClick"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span
                :class="node.disabled ? 'el-tree-node__label--disabled' : ''"
                >{{ node.label | format }}</span
              >
            </span>
          </el-tree>
        </template>
        <div
          v-if="searchString ? !!visibleSearchBtn : !!visibleLoadMoreBtn"
          class="add-option-btn"
        >
          <span class="add-option-btn__title fw-500 secondary">ДЕЙСТВИЯ</span>
          <span
            v-loading="loading"
            @click="loadMore"
            class="blue add-option-btn__action"
          >
            <Icon iconName="refresh" iconColor="#0075DB" />
            Загрузить еще
          </span>
        </div>
      </el-select>
    </Tooltip>
  </div>
</template>

<script>
import { store } from '@/store';
import { Tree, Select, Option } from 'element-ui';
import { form, mixin, errorMsg } from '@/utils/mixins';
import { getController } from '@/controllers/request.js';
import Tooltip from 'Elements/Tooltip/Tooltip';
import Icon from 'Elements/Icon/Icon';
export default {
  mixins: [form, mixin, errorMsg],
  inheritAttrs: false,
  props: {
    field: {
      type: Object,
      default: () => ({
        name: '',
        required: false,
        placeholder: '',
        disabled: false
      })
    },
    options: {
      type: Array,
      default: () => []
    },
    model: {
      type: String
    },
    size: {
      type: String,
      default: 'big'
    },
    emitEvent: { type: String, default: 'set-value' },
    callback: {
      type: [Function, Object],
      default: null
    },
    module: String,
    label: String,
    simpleErrors: {
      type: Boolean, // искусственная подсветка ошибок
      default: false
    },
    multiple: { type: Boolean, default: false },
    visibleLoadMoreBtn: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    clearable: {
      type: Boolean
    },
    lazyLoaded: Boolean
    // record: { type: String, default: '' }
  },
  data() {
    return {
      defaultCheckedKeys: [],
      localModel: {},
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
        disabled: 'disabled'
      },
      searchString: '',
      simpleOptions: null,
      selectBySearchMode: false,
      visibleSearchBtn: this.visibleLoadMoreBtn,
      maxOptionsWidth: 'auto',
      autoExpandAll: false,
      updateTree: 0
    };
  },
  async created() {
    if (this.model && this.model[0] !== '') {
      this.defaultCheckedKeys = [this.model];
    }
    if (
      this.field.visual_type === 'multi-level-lazy' ||
      this.field.type == 'multiLevelEnumLazy'
    ) {
      this.$emit('set-label', this.model);
    }
    const model = await this.findNested(this.options);
    if (model) this.localModel = model || {};
  },
  mounted() {
    // задаем максимальную ширину списков опций
    const dropdownEl = this.$refs[this.field.name];
    this.maxOptionsWidth = dropdownEl
      ? dropdownEl.$el.offsetWidth + 'px'
      : 'auto';
  },
  computed: {
    getLengthChangeableList() {
      return store.state.candidate.changeableVacCandList?.list?.length
        ? store.state.candidate.changeableVacCandList.list
        : this.module == 'HRPAC_VACANCY'
        ? store.state.vacancy.changeableList.list
        : store.state.candidate.changeableList.list;
    },
    showClearButton() {
      return (
        this.clearable &&
        !(this.disabled(this.field) || this.field.disabled) &&
        !!this.localModel?.id &&
        !this.field.readonly &&
        !this.field.disabled &&
        !(this.field.isMultiSelect || this.field.multiple)
      );
    }
  },
  watch: {
    searchString(val) {
      if (!this.$refs.tree) return;
      this.$refs.tree.filter(val);
    },
    model: async function () {
      if (this.model !== this.localModel?.id) {
        const model = await this.findNested(this.options);
        this.localModel = model || {};
        if (this.model && this.model[0] !== '') {
          this.defaultCheckedKeys = [this.model];
        }
      }
    },
    visibleOptionBtn: function () {
      if (this.visibleOptionBtn) {
        const timer = setInterval(() => {
          const elSelect = $('.add-option-btn').closest(
            '.el-scrollbar.is-empty'
          );

          if (elSelect?.length > 1) return;
          if (elSelect.length) {
            elSelect.show(); // переопределяем библиотечные стили
            // перемещаем элемент с удалением во избежание дублирования:
            elSelect.closest('.el-select-dropdown').append(elSelect.remove());
            clearInterval(timer);
          }
        }, 100);

        setTimeout(() => clearInterval(timer), 1000);
      }
    },
    showClearButton: function () {
      if (this.showClearButton) {
        setTimeout(() => {
          let input = this.$refs[this.field.name || 'dropdown']?.$el;
          if (!input) return;
          let clearIcon = this.$refs['clear_icon'];
          let suffixArea = input?.getElementsByClassName(
            'el-input__suffix-inner'
          )[0];
          if (clearIcon) suffixArea?.append(clearIcon);
        }, 0);
      }
    },
    lazyLoaded: function () {
      if (this.lazyLoaded) {
        this.updateTree++;
        this.$emit('reset-lazy-loaded');
      }
    }
  },
  methods: {
    async findNested(arr = []) {
      let found = arr.find(node => node.id === this.model);
      if (found) return { ...found, name: this.label };

      for (let i = 0; i < arr.length; i++) {
        if (!arr[i].children && !arr[i].children_request) continue;

        if (arr[i].children_request) {
          const resp = await getController({ params: arr[i].children_request });
          const foundNested = await this.findNested(resp.data);
          return { ...foundNested, name: this.label };
        }

        const foundNested = await this.findNested(arr[i].children);
        if (arr[i]?.children.length && foundNested) {
          return { ...foundNested, name: this.label };
        }
      }
    },
    filter(val) {
      this.searchString = val || '';
      this.inputPause();
    },
    inputPause() {
      if (!this.searchString) {
        this.$emit('filter-option', this.searchString);
        if (this.inputTimer != null) clearTimeout(this.inputTimer);
        this.simpleOptions = null;
        return;
      }

      if (this.inputTimer != null) clearTimeout(this.inputTimer);

      this.inputTimer = setTimeout(async () => {
        const record = this.getLengthChangeableList?.length
          ? this.getLengthChangeableList[0]?.ID
          : '';
        if (!this.field['multi-level-schema']?.search) return;
        let url =
          this.field['multi-level-schema'].search +
          `${record ? `&record=${record}&offset=0` : ''}`;

        const limit = this.field['multi-level-schema'].limit || '';
        if (limit) url += `&limit=${limit}`;

        if (this.field.control_fields) {
          this.field.control_fields.forEach(name => {
            url += `&control_fields[${name}]=${this.form[name] || ''}`;
          });
        }
        const resp = await getController({
          url,
          params: {
            search_string: this.searchString
          }
        });

        if (!resp) {
          this.inputTimer = null;
          return;
        }

        this.visibleSearchBtn =
          limit &&
          (Array.isArray(resp.data)
            ? resp.data.length == limit
            : Object.values(resp.data).length == limit);
        this.simpleOptions =
          Array.isArray(resp.data) && !resp.data.length ? false : resp.data;
        this.inputTimer = null;
      }, 1000);
    },
    blur(e) {
      // для автоподстановки поискового слова в инпут при постраничной подгрузке опций
      setTimeout(
        () =>
          (e.target.value = this.searchString || this.localModel?.name || ''),
        200
      );
    },
    async search() {
      const record = this.getLengthChangeableList?.length
        ? this.getLengthChangeableList[0]?.ID
        : '';
      const params = {
        offset: this.simpleOptions
          ? Object.values(this.simpleOptions).length
          : 0,
        search_string: this.searchString.trim()
      };

      this.visibleSearchBtn = false;
      if (!this.field['multi-level-schema']?.search) return;
      let url =
        this.field['multi-level-schema'].search +
        `&search_string=${this.searchString}${
          record ? `&record=${record}` : ''
        }`;
      const limit = this.field['multi-level-schema']?.limit || 0;
      if (limit) params.limit = limit;

      if (this.field.control_fields) {
        this.field.control_fields.forEach(name => {
          url += `&control_fields[${name}]=${this.form[name] || ''}`;
        });
      }

      const resp = await getController({
        url,
        params
      });

      if (!resp) return;

      this.visibleSearchBtn =
        limit &&
        (Array.isArray(resp.data)
          ? resp.data.length == limit
          : Object.values(resp.data).length == limit);
      this.simpleOptions = { ...this.simpleOptions, ...resp.data };
    },
    visibleChange(visible) {
      const ref = this.$refs[this.field.name || 'dropdown'];
      if (
        this.searchString &&
        !!this.simpleOptions &&
        this.selectBySearchMode
      ) {
        if (!visible) ref.visible = true;
        return;
      }
      if (!visible) {
        this.simpleOptions = null;
        this.searchString = '';
        this.autoExpandAll = false;
      }
      if (visible) {
        this.$emit('filter-option', this.searchString);
      }
    },
    async changeValue(opt) {
      this.selectBySearchMode = true;
      const record = this.getLengthChangeableList?.length
        ? this.getLengthChangeableList[0]?.ID
        : '';
      if (!this.field['multi-level-schema']?.getById) return;
      let url =
        this.field['multi-level-schema'].getById +
        `&search_id=${opt}${record ? `&record=${record}` : ''}`;

      if (this.field.control_fields) {
        this.field.control_fields.forEach(name => {
          url += `&control_fields[${name}]=${this.form[name] || ''}`;
        });
      }

      this.localModel = {};
      await this.$emit('filter-option', this.searchString, null, url);
      this.autoExpandAll = true;
      this.simpleOptions = null;
      this.searchString = '';
      this.selectBySearchMode = false;
    },
    async handleNodeClick(node /* , tree */) {
      if (node.disabled) return;

      // запрос для получения лейбла
      const { data } = await getController({
        url: `index.php?module=${this.field?.module}&action=get_visual_value&record=${node.id}&referrer_module=${this.module}`
      });

      if (!data) return;
      if (data.error && data.status == 'error') {
        this.showErrorMessage('Возникла ошибка при обновлении значения');
        return;
      }

      this.searchString = '';
      this.localModel = {
        ...node,
        id: data.id,
        name: this.formatHtml(data.name)
      };

      this.setValue();
    },
    setValue() {
      this.$emit(
        this.emitEvent,
        this.field.name,
        this.field.type == 'multiLevelEnumLazy'
          ? this.localModel?.id || ''
          : this.localModel?.name || '',
        this.field.blocked,
        true // для параметра trigger и вызова метода очистки по self_clean
      );

      if (
        this.field.visual_type === 'multi-level-lazy' ||
        this.field.type == 'multiLevelEnumLazy'
      )
        this.$emit('set-label', this.localModel?.name || '');

      if (this.callback) {
        if (this.callback && this.callback.field) {
          this.callback.field.change(
            this.field,
            this.field.visual_type === 'multi-level-lazy' ||
              this.field.type == 'multiLevelEnumLazy'
              ? this.localModel?.id || ''
              : this.localModel?.name || '',
            this.field.blocked
          );
        } else {
          this.callback(
            this.field.visual_type === 'multi-level-lazy' ||
              this.field.type == 'multiLevelEnumLazy'
              ? this.localModel?.id || ''
              : this.localModel?.name || ''
          );
        }
      }

      const { id_name, name } = this.field;
      this.$emit('change-option', name, id_name, this.localModel);
    },
    async loadNode(node, resolve) {
      if (this.autoExpandAll && node.data.children_request) {
        this.$nextTick(() => {
          node.loading = false;
          this.autoExpandAll = false;
          if (this.$refs.tree) this.$refs.tree.store.defaultExpandAll = false;
        });
        return;
      }

      if (this.simpleOptions) this.simpleOptions = null;

      const isLeaf = (arr = []) =>
        arr.map(i =>
          !!i?.children?.length || !!i?.children_request
            ? { ...i, leaf: false }
            : { ...i, leaf: true }
        );

      if (!node.data.children_request) {
        node.loaded = true;
      }

      if (node.level == 0) {
        return resolve(isLeaf(node.data));
      }

      if (node.data?.children?.length) {
        return resolve(isLeaf(node.data.children));
      }

      // запрос получения вложенных узлов
      if (node.loaded && !node.data.children_request) {
        return resolve([]);
      }

      if (node.data.children_request) {
        const resp = await getController({
          params: node.data.children_request
        });

        node.loaded = true;
        resolve(isLeaf(resp.data));
      }
    },
    async loadMore() {
      if (this.searchString) this.search();
      else {
        await this.$emit('load-more', this.searchString);
      }
    },
    clear() {
      this.localModel = {};
      this.setValue();
      this.defaultCheckedKeys = [];
    }
  },
  components: {
    'el-tree': Tree,
    'el-select': Select,
    'el-option': Option,
    Tooltip,
    Icon
  }
};
</script>
<style lang="scss">
.el-tree {
  &-node {
    &__label {
      &--disabled {
        color: $grey40;
      }
    }
  }
  &-node__content {
    width: 99.9%;
    margin-right: -1px;
  }

  &-node__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &--highlight-current
    .el-tree-node.is-current[aria-disabled='true']
    > .el-tree-node__content {
    background-color: inherit;
  }

  //   &__empty-block {
  //     min-height: 24px;
  //     text-align: left;
  //   }

  //   &__empty-text {
  //     position: relative;
  //     left: unset;
  //     top: unset;
  //     margin-left: 12px;
  //   }

  //   .el-tree-node.is-current > .el-tree-node__content {
  //     background-color: $grey8;
  //   }
}
// .el-select-dropdown.multigroup-select {
// display: none !important;
// }

.empty-opt {
  height: 0 !important;
  line-height: 0 !important;
}

.add-option-btn {
  &__title {
    display: block;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 8px 16px;
  }

  &__action {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 18px;
    padding: 2px 16px;
    cursor: pointer;

    svg {
      margin-right: 4px;
    }
  }
}
</style>
<style lang="scss" scoped>
.el-select {
  width: 100%;

  & ::v-deep .el-select__caret.is-reverse {
    transform: rotateZ(180deg);
  }

  & ::v-deep .el-select__caret {
    display: block;
    content: url(/style/img/big-arrow-down.svg);
    line-height: 20px;
    padding-bottom: 0 !important;
    transform: rotateZ(0deg);
  }

  & ::v-deep .el-input__inner {
    border-radius: 4px;
    font-size: 16px;
    color: $black-190;
    font-family: 'Roboto', sans-serif;
  }

  // & ::v-deep .el-input__suffix {
  //   &-inner {
  //     pointer-events: none;
  //   }
  // }

  & ::v-deep .el-input__prefix {
    left: 0 !important;

    .el-input__icon:before {
      content: '';
      width: 24px;
      height: 24px;
      display: inline-block;
      background-size: 20px 20px;
      background-repeat: no-repeat;
      background-position: center center;
      position: absolute;
      top: 50%;
      left: 12px;
      margin-top: -12px;
    }
  }

  & ::v-deep .el-icon-arrow-up::before {
    content: url('/front/public/style/img/arrow-down.svg');
  }

  & ::v-deep .el-input__icon {
    line-height: 20px;
    padding-bottom: 2px;
  }

  & ::v-deep &__input {
    border: none;
    background-color: inherit;
  }

  &.clearable ::v-deep .el-input__suffix-inner {
    flex-direction: row-reverse;
    pointer-events: unset;

    .el-icon-close {
      content: url(/style/img/cross-small.svg);
      width: 16px;
      height: 16px;
      pointer-events: all;
      padding-bottom: 0;
      cursor: pointer;
    }
  }

  &.clearable ::v-deep .el-input__suffix {
    pointer-events: unset;
  }
}

.el-select-dropdown.el-popper {
  font-family: Roboto, sans-serif;
}

.dropdown-el__option {
  font-family: 'Roboto', sans-serif;

  &-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    svg {
      cursor: pointer;
    }
  }

  &.is-disabled {
    color: $black-50 !important;

    &:hover {
      background-color: unset;
    }

    & ::v-deep span {
      pointer-events: none;
    }
  }
}
</style>
